import Vue from 'vue';
import moment from 'moment';
import { TIPI_DOCUMENTO } from '@/utils';

Vue.filter('date', value => moment(value).format('DD/MM/YYYY HH:mm'));
Vue.filter('prettyDate', value => moment(value).format('ddd DD/MM HH:mm'));
Vue.filter('time', value => moment(value).format('HH:mm'));
Vue.filter('documento', value => TIPI_DOCUMENTO[value]);
Vue.filter('fixText', value => `${value[0].toUpperCase()}${value.substring(1).toLowerCase()}`);
Vue.filter('lowercase', value => value.toLowerCase());
Vue.filter('descrVariante', (value) => {
  const parts = value.split('   ');
  const descr = parts.pop();
  parts.pop(); // toglie gruppo 'VARIANTI'
  const gruppo = parts
    .map(part => part.replace(/\[\w+\] /, ''))
    .join(' - ');
  return `[ ${gruppo} ] ${descr}`;
});
